import * as React from "react"
import styled from "styled-components"
import { theme } from "../../theme"

interface ButtonProps {
  title: string
  onClick?: () => void
  color?: string
  active?: boolean
  icon?: JSX.Element
  subMenu?: boolean
}

const ButtonStyle = styled.div<{
  color: string
  active?: boolean
  subMenu?: boolean
}>`
  font-weight: 500;
  font-size: 20px;
  font-family: Karla, sans-serif;
  color: ${(props) => props.color};

  text-decoration-line: ${(props) => (props.active ? "underline" : undefined)};
  text-underline-offset: 8px;
  text-decoration-thickness: 3px;
  text-underline-offset: ${(props) => props.theme.spacings.medium};
  white-space: nowrap;
  cursor: pointer;

  :hover {
    filter: brightness(60%);
  }

  display: flex;
  place-items: center;
  justify-content: startx;
  gap: ${(props) => props.theme.spacings.medium};
`

const NavigationTextButton: React.FunctionComponent<ButtonProps> = ({
  title,
  onClick,
  color = theme.colors.greyDark,
  subMenu = false,
  active,
  icon,
}) => {
  return (
    <ButtonStyle onClick={onClick} color={color} active={active} subMenu={subMenu}>
      {title}
      {icon}
    </ButtonStyle>
  )
}

export default NavigationTextButton
